//frontend/src/components/Chat/matrix.js  --конфигурация Matrix.

export const MATRIX_HOMESERVER =
(
  process.env.REACT_APP_MATRIX_HOMESERVER ||
  "https://ruschinawiki.duckdns.org"
).replace(/\/+$/, "");


export function getMatrixBaseUrl() {
  return MATRIX_HOMESERVER;
}


export function getMatrixCredentials() {

  return {

    accessToken:
      localStorage.getItem(
        "matrix_access_token"
      ),

    userId:
      localStorage.getItem(
        "matrix_user_id"
      ),

  };

}


export function clearMatrixCredentials() {

  localStorage.removeItem(
    "matrix_access_token"
  );

  localStorage.removeItem(
    "matrix_user_id"
  );

}